<template>
	<v-container class="wrapper">
		<router-view></router-view>
	</v-container>
</template>
<script>
export default {}
</script>
<style lang="scss"></style>
